import { AccessorsMutatorsDecorator, Model } from "../../helpers";
import { Country } from "./country.model";

/**
 * @class BaseSubscription
 *
 */
export class BaseSubscription extends Model {

    static get validationModel() {

        return {
            from: {
                label: '#_OF_ROOMS_FROM',
                messages: {
                    lowerThan: 'THIS_VALUE_MUST_BE_LOWER_THAN_TO',
                }
            },
            to: {
                label: '#_OF_ROOMS_TO',
                messages: {
                    greaterThan: 'THIS_VALUE_MUST_BE_GREATER_THAN_FROM',
                }
            },
        };
    }

    /**
     * @param {Object|Country} value
     * @returns {Country}
     */
    setCountry(value) {

        if (!value) {

            return value;
        }

        return value instanceof Country ? value : new Country(value);
    }
}

AccessorsMutatorsDecorator('id', 'country', 'country_id', 'from', 'to', 'price', 'price_with_vat', 'notify_owners', 'subscriptions', 'oldTo', 'isExists')(BaseSubscription);



// WEBPACK FOOTER //
// ./src/pms-api/models/base-subscription.model.js